export default [
  {
    path: "/providers",
    name: "Providers-list",
    component: () => import("@/views/provider/index.vue"),
    meta: {
      resource: "Provider",
      action: "View",
    },
  },
  {
    path: "/cybersource/profiles",
    name: "profiles-list",
    component: () => import("@/views/cybesource/profiles.vue"),
    meta: {
      resource: "CybersourceProfile",
      action: "View",
    },
  },
  {
    path: "/cybersource/add",
    name: "cybersource-add",
    component: () => import("@/views/cybesource/add.vue"),
    meta: {
      resource: "CybersourceProfile",
      action: "Create",
    },
  },
];
